import { Route } from 'react-router-dom';
import { createRoute } from '@core/router';
import productDetailRoute from '@modules/alert-reports/products/DetailPage';

const productsRoutes = <Route path="products/:id" {...createRoute(productDetailRoute)} />;

export default productsRoutes;
